module.exports = __webpack_public_path__ + "static/media/eulogo2.ef3cfb0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/eulogo2.png
// module id = 414
// module chunks = 0